
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.256 4.647c.218.376.327.563.327.77 0 .206-.109.394-.327.77L8.215 7.98c-.218.376-.327.564-.507.667-.18.103-.397.103-.833.103H4.792c-.436 0-.654 0-.834-.103-.18-.103-.288-.291-.506-.667L2.41 6.187c-.218-.376-.327-.564-.327-.77 0-.207.11-.394.327-.77l1.042-1.794c.218-.376.327-.563.506-.666.18-.104.398-.104.834-.104h2.083c.436 0 .654 0 .833.104.18.103.289.29.507.666l1.041 1.794zM17.59 9.647c.218.376.327.563.327.77 0 .206-.11.394-.327.77l-1.042 1.793c-.218.376-.327.564-.506.667-.18.103-.398.103-.834.103h-2.082c-.437 0-.655 0-.834-.103-.18-.103-.289-.291-.507-.667l-1.041-1.793c-.218-.376-.327-.564-.327-.77 0-.207.109-.394.327-.77l1.041-1.794c.218-.376.327-.563.507-.666.18-.104.397-.104.834-.104h2.082c.436 0 .654 0 .834.104.18.103.288.29.506.666l1.042 1.794zM9.256 13.813c.218.376.327.564.327.77 0 .207-.109.394-.327.77l-1.041 1.794c-.218.376-.327.563-.507.667-.18.103-.397.103-.833.103H4.792c-.436 0-.654 0-.834-.104-.18-.103-.288-.29-.506-.666L2.41 15.353c-.218-.376-.327-.563-.327-.77 0-.206.11-.394.327-.77l1.042-1.793c.218-.376.327-.564.506-.667.18-.103.398-.103.834-.103h2.083c.436 0 .654 0 .833.103.18.103.289.291.507.667l1.041 1.793z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    